import { InputAttachmentsPreview } from '@newfront-insurance/nova-core';

import { useAttachments } from './attachments-provider';

/**
 * Component that displays the preview of uploaded attachments.
 * Should be rendered below the textarea but above the toolbar.
 * The toolbar is absolutely positioned, so this appears in normal flow above it.
 */
export function ChatAttachmentsPreview() {
  const { attachments, setAttachments } = useAttachments();

  // Preview appears in normal flow, toolbar overlays it at bottom
  return <InputAttachmentsPreview attachments={attachments} setAttachments={setAttachments} />;
}
